import { UitkCardAlohaContentSection, UitkCardAloha } from "uitk-react-cards";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkFigure } from "uitk-react-images";
import { UitkIcon } from "uitk-react-icons";
import * as React from "react";
import { decorateEditorialHtml } from "components/flexComponents/Editorial/ContentUtilities";
import { uitkFigureAspectRatio } from "../editorials/EditorialWithLink";
import { LazyLoad } from "src/components/utility/LazyLoad/LazyLoad";
import { BlossomImage } from "src/components/shared/BlossomImage/BlossomImage";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useRenderableContext } from "./DefaultEditorial";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

export interface RenderableContentCardProps {
  shouldRenderBorder?: boolean;
  isExpandoEnabled?: boolean | "";
  toggleStatus: boolean;
  flipToggleStatus: () => void;
  displayEditorialClassNames: string;
}

export const RenderableContentCard = ({
  shouldRenderBorder,
  isExpandoEnabled,
  toggleStatus,
  flipToggleStatus,
  displayEditorialClassNames,
}: RenderableContentCardProps) => {
  const {
    context,
    boxType,
    key,
    media,
    imageAspectRatio = "16-9",
    padding,
    title,
    subtitle,
    text,
    view,
    trackRfrridClick,
    id,
  } = useRenderableContext();

  return (
    <LazyLoad context={context}>
      <UitkCardAloha
        className={boxType === "blossom-plain" ? "noBackground" : ""}
        border={shouldRenderBorder}
        key={key}
      >
        {media?.mediaUrl && (
          <UitkFigure ratio={uitkFigureAspectRatio(imageAspectRatio)}>
            <BlossomImage src={media.mediaUrl || ""} alt={media.mediaAlt || ""} />
          </UitkFigure>
        )}
        {isExpandoEnabled && (
          <div role="button" tabIndex={0} aria-expanded={!toggleStatus} className="header" onClick={flipToggleStatus}>
            <UitkCardAlohaContentSection padded={padding !== "none"} className={`${toggleStatus && "allBorderZero"}`}>
              <UitkLayoutFlex justifyContent="end">
                <UitkHeading tag="h2" size={4}>
                  {title}
                </UitkHeading>
                <UitkLayoutFlexItem>
                  <div>
                    <UitkSpacing margin={{ blockstart: "six" }}>
                      <UitkSubheading tag="h3">{subtitle}</UitkSubheading>
                    </UitkSpacing>
                  </div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkIcon name={`expand_${toggleStatus ? "more" : "less"}`} />
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkCardAlohaContentSection>
          </div>
        )}
        <div
          data-testid="editorial-content"
          className={`editorialContent ${isExpandoEnabled && toggleStatus ? "is-visually-hidden" : ""}`}
        >
          <UitkCardAlohaContentSection padded={padding !== "none"}>
            <UitkLayoutGrid>
              <UitkLayoutGridItem>
                <div className={displayEditorialClassNames} data-fm-content={id} id={id}>
                  {title && !isExpandoEnabled && (
                    <UitkHeading tag="h2" size={4}>
                      {title}
                    </UitkHeading>
                  )}
                  {subtitle && !isExpandoEnabled && <UitkSubheading tag="h4">{subtitle}</UitkSubheading>}
                  {text && (
                    <UitkSpacing padding={{ blockstart: "two" }}>
                      <div
                        onClick={trackRfrridClick && trackRfrridClick(useClickTracker())}
                        className={`uitk-type-list-300 ${
                          view === "single-column" ? "singleColumn" : "editorialTextColumn"
                        }`}
                        dangerouslySetInnerHTML={decorateEditorialHtml(text)}
                      />
                    </UitkSpacing>
                  )}
                </div>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkCardAlohaContentSection>
        </div>
      </UitkCardAloha>
    </LazyLoad>
  );
};
